(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-sling-styles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pl-sling-scroll')) {
 customElements.define('pl-sling-scroll',class extends HTMLElement {
 connectedCallback(){
 this.rail=this.querySelector('.pl-style-rail');this.control=this.querySelector('input');
 this.sync=()=>{const max=this.rail.scrollWidth-this.rail.clientWidth;this.control.hidden=max<2;this.control.value=max>0?Math.round(this.rail.scrollLeft/max*1000):0;this.control.style.setProperty('--pl-thumb',Math.max(32,this.control.clientWidth*this.rail.clientWidth/this.rail.scrollWidth)+'px');};
 this.move=()=>{this.rail.scrollLeft=(this.rail.scrollWidth-this.rail.clientWidth)*Number(this.control.value)/1000;};
 this.rail.addEventListener('scroll',this.sync,{passive:true});this.control.addEventListener('input',this.move);this.resize=new ResizeObserver(this.sync);this.resize.observe(this.rail);this.sync();
 }
 disconnectedCallback(){this.resize?.disconnect();this.rail?.removeEventListener('scroll',this.sync);this.control?.removeEventListener('input',this.move);}
 });
}

  } catch(e) { console.error(e); }
})();
})();
